import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { withTranslation } from 'react-i18next'

import { getOrganizationSettingsEntityWelcomeEmailAndLanding } from 'store/entities/organizationSettings/selectors'
import { subscribeToProTrack, setIsUserEverTakeProTrack } from 'store/entities/identity/actions'
import {
  getOnboardingNewProTrackLevels,
  getTimePreferences,
  getIdentityUserData,
  isUserEverTakeProTrack,
} from 'store/entities/identity/selectors'
import { getUserNameOrEmail } from 'helpers/getUserUIData'
import OnboardingLanding from './OnBoardingLanding'

const mapStateToProps = state => ({
  proTrackLevels: getOnboardingNewProTrackLevels(state),
  timePreferences: getTimePreferences(state),
  user: getIdentityUserData(state),
  welcomeEmailSettings: getOrganizationSettingsEntityWelcomeEmailAndLanding(state),
  isUserEverTakeProTrack: isUserEverTakeProTrack(state),
})

const mapDispatchToProps = dispatch => ({
  setQueriesAndGoToDashboard: id => {
    dispatch(subscribeToProTrack({ proTrackLevelId: id }))
  },
})

const mergeProps = (
  { timePreferences, user, welcomeEmailSettings, ...stateProps },
  { saveProfile, ...dispatchProps },
  ownState
) => {
  const text = welcomeEmailSettings.get('text')

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownState,
    fullNameOrEmail: getUserNameOrEmail(user.get('firstName'), user.get('lastName'), user.get('email')),
    quoteImage: welcomeEmailSettings.get('quoteImage'),
    text,
    isTextIncludeHtmlTags: text ? text.includes('<') : false,
  }
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(withTranslation('user')(OnboardingLanding))
